import { isEmpty, filter, isArray, includes, get, has, toString } from "lodash";
import $ from "jquery";

const globalConfig = {
    theme: 'tailwindcss-3',
    placeholder: "Please select from below options.",
    width: '100%'
}

const initSelect2 = () => {
    $('[data-toggle="select2"]').select2(globalConfig);

    const select2MultipleEl = $('[data-toggle="select2-multiple"]');
    select2MultipleEl.attr('multiple', 'multiple');
    select2MultipleEl.each(function () {
        $(this).find("option").filter(function () {
            return !this.value.trim();
        }).remove();
    });
    select2MultipleEl.select2({
        ...globalConfig,
        multiple: true,
        allowClear: true,
    });
}

const handleSelect2Filter = (fieldId, options, key, value) => {
    let result;
    let defaultValue;

    if (isEmpty(fieldId) || isEmpty(options) || isEmpty(key)) {
        return;
    }

    fieldId = $.escapeSelector(fieldId);
    const field = $(`#${fieldId}`);
    if (isEmpty(field) || field.length === 0) {
        return;
    }

    options = filter(options, (option) => {
        return (get(option, 'value') !== null) && (get(option, 'name') !== null);
    });

    if (isEmpty(value)) {
        result = options.map(option => ({
            id: get(option, 'value'),
            text: get(option, 'name'),
            [key]: get(option, key),
        }));
        field.empty();
        field.select2({
            ...globalConfig,
            data: result,
        });
        return;
    }

    result = filter(options, (option) => {
        if (has(option, key)) {
            let currentValue = toString(get(option, key));
            return isArray(value) ? includes(value, currentValue) : (currentValue === value);
        }
        return true;
    });

    if (!isEmpty(result)) {
        defaultValue = field.val();

        result = result.map(option => {
            return {
                id: get(option, 'value'),
                text: get(option, 'name'),
                [key]: get(option, key),
                selected: isArray(defaultValue) ? includes(defaultValue, toString(get(option, 'value'))) : (defaultValue === toString(get(option, 'value'))),
            };
        });
    }

    field.empty();
    field.select2({
        ...globalConfig,
        data: result ?? [],
    });
}

export {
    handleSelect2Filter,
    initSelect2
};
